module.exports = __webpack_public_path__ + "img/3D_Model_Flatline.8cf70e7e.svg";